export enum PersonaBlobFetchStatus {
    None,
    Pending,
    Failed,
    Success,
}

interface PersonaBlob {
    blobUrl: string;
    FetchStatus: PersonaBlobFetchStatus;
}

export default PersonaBlob;
